/* eslint-disable camelcase */
const gtag = {
  send({
    event = null, // The event name. This field is required.
    action = null, // Indicates the user action taken such as a click or impression.
    category = null, // The event category such as a page title, booking category name, or other descriptive name of the page.
    id = null, // The unique ID of the event. Either the specific booking ID or in the case of page views a unique URL for the page.
    category_id = null, // A secondary ID that can be used to group events by a category such as a booking category ID.
    location = null, // Usually the URL of the page where the event occurred.
  }) {
    location = location ?? window.location.href;

    // console.log(`gtag-event::${event}`, {
    //   category, action, id, category_id, location,
    // });

    try {
      window.dataLayer.push({
        event, category, action, id, category_id, location,
      });
    } catch (e) {
      console.log(e);
    }
  },
};

// eslint-disable-next-line no-alert
Object.assign(window, { gtag });

export default gtag;

console.log('gtag: loaded');
